{
  "title": "Validation",
  "lead": "Every biome at once: the pack's biomes as the game builds them (with the workshop's saved changes) and the workshop's user biomes, over many seeds and floors with the engine's own generator and validator (delve-sim).",
  "seeds": "Seeds",
  "floors": "Floors",
  "party": "Party",
  "run": "Validate every biome",
  "cancel": "Cancel ({{done}}/{{total}})",
  "export": "Download the report",
  "idle": "Validates {{count}} biomes of {{pack}}.",
  "progress": "Validating {{name}} ({{done}}/{{total}})…",
  "cancelled": "Cancelled: {{done}} of {{total}} biomes validated.",
  "allOk": "✔ Every biome is playable",
  "someBad_one": "✖ {{count}} biome with problems",
  "someBad_other": "✖ {{count}} biomes with problems",
  "simOff": "delve-sim is not available (see the status bar).",
  "noBiomes": "This pack has no biome to validate.",
  "tiles": {
    "biomes": "Biomes",
    "floors": "Floors generated",
    "failed": "Floors failing"
  },
  "kind": { "pack": "pack", "packChanged": "pack, changed", "user": "user" },
  "col": {
    "biome": "Biome",
    "kind": "Kind",
    "result": "Result",
    "problems": "Problems",
    "avgMs": "Avg ms",
    "maxMs": "Max ms",
    "floor": "Floor",
    "failed": "Failed"
  },
  "stat": {
    "rooms": "Rooms",
    "tiles": "Floor tiles",
    "locks": "Locks",
    "keys": "Keys",
    "spawns": "Monster spots",
    "spawners": "Spawners",
    "treasure": "Treasure",
    "potions": "Potions",
    "food": "Food",
    "hazards": "Hazards",
    "path": "Walk to exit"
  },
  "result": {
    "waiting": "waiting…",
    "running": "running…",
    "ok": "✔ {{floors}} floors",
    "bad": "✖ {{failed}}/{{floors}} floors fail",
    "none": "✖ not validated",
    "okText": "OK",
    "badText": "{{failed}}/{{floors}} floors fail",
    "noneText": "not validated"
  },
  "unreadable": "The file cannot be read (made by a newer game).",
  "simError": "delve-sim: {{error}}",
  "failure": "seed {{seed}}, floor {{depth}}: {{issues}}",
  "detail": "Per floor of {{name}}",
  "detailHint": "Averages over the seeds; walk to exit in tiles, average (min–max).",
  "pick": "Pick a biome in the table for its floors and problems.",
  "problems": "Problems (each opens that floor in Dungeons)",
  "noProblem": "✔ No problem",
  "open": "Open in Dungeons",
  "report": {
    "title": "Biome validation",
    "setup": "{{seeds}} seeds × {{depths}} floors, party of {{party}}."
  }
}
